import { Button, withStyles } from '@material-ui/core';

const BlueButton = withStyles({
  root: {
    minWidth: '30px',
    color: '#00B5E2',
    fontWeight: 700,
    padding: '0px 25px',
    margin: 5,
    borderRadius: 5,
    fontSize: '1.3rem',
    border: '2px solid #00B5E2',
    '&:hover': {
      background: '#00B5E2',
      color: 'white',
    },
    '&:active': {
      background: '#00B5E2',
      color: 'white',
    },
  },
  disabled: {
    background: '#C4C4C4',
  },
})(Button);

export default BlueButton;
